import React, { useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import api from "../../api/axios";
import { ErroContainer } from "../../styles/GlobalStyles";
import { toast } from "react-toastify";

export const ProfessionalOccurrencesModal = ({
  open,
  onClose,
  mode,
  occurrence,
  professional,
  getOccurrences,
}) => {
  const [values, setValues] = useState({
    professional: "",
    title: "",
    oportunity: null,
    date: null,
    description: "",
  });

  const [oportunities, setOportunities] = useState([]);

  const [error, setError] = useState("");

  const getOportunities = async () => {
    try {
      const { data } = await api.get(
        `/application/get-by-professional/${professional._id}`,
      );
      setOportunities(data);
    } catch (err) {
      console.log(err);
      toast.error("Ocorreu um erro");
    }
  };

  const handleSubmit = async () => {
    setError("");

    const isFormValid = Object.values(values).every((v) => v !== "");

    if (!isFormValid) {
      setError("Por favor, preencha todos os campos!");
      return;
    }

    if (!values.date) values.date = new Date();

    if (mode === "create") {
      try {
        await api.post(`/professional_occurrence/create`, values);
        resetValues();
        handleClose();
      } catch (error) {
        console.log("Erro", error);
        toast.error(error);
      }
    } else {
      try {
        console.log(values);
        await api.put(
          `/professional_occurrence/update/${occurrence._id}`,
          values,
        );

        resetValues();
        handleClose();
      } catch (error) {
        toast.error(error);
      }
    }
  };

  const handleDelete = async () => {
    try {
      await api.delete(`/professional_occurrence/delete/${occurrence._id}`);

      resetValues();
      handleClose();
    } catch (error) {
      toast.error(error);
    }
  };

  const handleClose = () => {
    resetValues();
    getOccurrences(professional._id);
    setError("");
    onClose();
  };

  const resetValues = () => {
    setValues({
      professional: professional._id,
      title: "",
      oportunity: null,
      date: null,
      description: "",
    });
  };

  useEffect(() => {
    if (occurrence) {
      setValues(occurrence);
    }
  }, [occurrence]);

  useEffect(() => {
    if (professional) {
      setValues({ ...values, professional: professional._id });
      getOportunities();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [professional]);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "900px",
          minWidth: "300px",
        },
      }}
    >
      <DialogTitle textAlign="center">{`${
        mode === "edit"
          ? "Editar"
          : mode === "create"
            ? "Criar Nova"
            : "Deseja remover esta"
      } Ocorrência${
        mode === "delete" ? "? (Essa ação é irreversível)" : ""
      }`}</DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            width: "100%",
            minWidth: "300px",
            gap: "1.5rem",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label for="oportunity" style={{ marginBottom: "10px" }}>
              Oportunidade:
            </label>
            <Select
              id="oportunity"
              name="oportunity"
              label="Oportunidade"
              disabled={oportunities.length < 1}
              value={values.oportunity || null}
              onChange={(e) =>
                setValues({ ...values, oportunity: e.target.value })
              }
            >
              <MenuItem value={null}>Nenhuma</MenuItem>
              {oportunities.map((item) => (
                <MenuItem
                  value={item._id}
                >{`${item?.oportunity?.cargo} (${item?.oportunity?.empresa})`}</MenuItem>
              ))}
            </Select>
          </div>
          <TextField
            label="Título"
            id="title"
            name="title"
            type="text"
            value={values.title}
            disabled={mode === "delete"}
            onChange={(e) => {
              setValues({ ...values, title: e.target.value });
              setError("");
            }}
          />
          <TextField
            label="Descrição"
            id="description"
            name="description"
            type="text"
            value={values.description}
            disabled={mode === "delete"}
            onChange={(e) => {
              setValues({ ...values, description: e.target.value });
              setError("");
            }}
            multiline
            minRows={4}
            maxRows={10}
          />
        </Stack>
        <ErroContainer>{error ? error : ""}</ErroContainer>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button sx={{ color: "#104467" }} onClick={handleClose}>
          Fechar
        </Button>
        <Button
          sx={{ backgroundColor: "#104467", color: "white" }}
          onClick={mode === "delete" ? handleDelete : handleSubmit}
          variant="contained"
        >
          {mode === "delete" ? "Confirmar" : "Salvar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
